import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function MaltaCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Malta Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate in Europe’s Trusted Business & Financial Hub</h3>
                            <p className='page-paragraph'>
                                A <b>Malta company</b> provides the benefits of <b> EU credibility, favorable taxation, and global banking access.</b> Known for its strong presence in <b> iGaming, fintech, shipping, and asset management,</b> Malta is one of the best jurisdictions for entrepreneurs and corporations looking to establish a European base.
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "EU Access",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Effective 5% Corporate Tax",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "iGaming & FinTech Hub",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Banking Access",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Malta Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Incorporate in Malta?</h3>
                        <PageList
                            items={[
                                {
                                    title: "EU & Eurozone Jurisdiction",
                                    paragraph: "Full access to European markets",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Low Effective Tax Rate",
                                    paragraph: "Refunds reduce corporate tax to ~5%",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "iGaming & FinTech Hub",
                                    paragraph: "World leader in licensing & innovation",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor Confidence",
                                    paragraph: "Respected by banks & regulators",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Double-Tax Treaties",
                                    paragraph: "Over 70 tax treaties worldwide",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Types of Companies in Malta
                        </h3>
                        <p className='page-subtitle'>1. Private Limited Company (Ltd)</p>
                        <PageList
                            items={[
                                { paragraph: "Most common company type.", icon: GoDotFill },
                                { paragraph: "Used for iGaming, forex, shipping, and holding companies.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. Public Limited Company (PLC)</p>
                        <PageList
                            items={[
                                { paragraph: "Required for larger businesses and regulated activities.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>3. Holding & Trading Companies</p>
                        <PageList
                            items={[
                                { paragraph: "Popular for asset protection, royalty flows, and tax structuring.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>4. Branch / Subsidiary</p>
                        <PageList
                            items={[
                                { paragraph: "For foreign companies expanding into the EU market.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders",
                                    paragraph: "At least 1 (individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "Minimum 1 (local or foreign)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Secretary",
                                    paragraph: "Mandatory",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registered Office",
                                    paragraph: "Must be in Malta",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Share Capital",
                                    paragraph: "Minimum EUR 1,165 (20% paid-up)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Filing",
                                    paragraph: "Audited accounts required",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of Malta Companies</h3>
                        <PageList
                            items={[
                                {
                                    title: "Effective Tax",
                                    paragraph: "~5% with refund system",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "EU Passport for Business",
                                    paragraph: "Credibility with regulators & investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Access",
                                    paragraph: "Easier than Caribbean offshore jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Sector Focused",
                                    paragraph: "Strong in iGaming, fintech, shipping, and funds",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor-Friendly",
                                    paragraph: "Treaty network & tax planning options",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Planning",
                                    paragraph: "Define structure & activities",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "With Malta Business Registry (MBR)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Drafting of Memorandum & Articles",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Registration",
                                    paragraph: "Filing with MBR",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "VAT & Tax Registration",
                                    paragraph: "As required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Opening",
                                    paragraph: "Local or EU banks",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Timeline & Costs
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "2–3 weeks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From EUR 7,500+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Accounting, audits, registered office, compliance",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Common Uses of Malta Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "iGaming operators (MGA licensing)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Forex & brokerage entities (MFSA-regulated)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Fund management & asset holding",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Shipping companies & yacht ownership",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Royalty & intellectual property structuring",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Why Offshore Advisory?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Malta incorporation & licensing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong links with local lawyers, auditors, and regulators",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Full-service support",
                                    paragraph: "Company setup, tax structuring, compliance",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Malta vs Cyprus vs Gibraltar vs Isle of Man",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing annual filings & nominee services",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a European company with low effective tax?"
                        description="A Malta company combines EU credibility, tax efficiency, and strong banking access."
                        buttonText="Book a Malta Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default MaltaCompanyFormation

const faqData = [
    {
        question: "What is the corporate tax in Malta?",
        content: [
            { type: "answer", text: "35% headline rate, but effective ~5% after shareholder refunds." },
        ],
    },
    {
        question: "Is a local director required?",
        content: [
            { type: "answer", text: "Not mandatory, but recommended for substance & banking." },
        ],
    },
    {
        question: "How much capital is required?",
        content: [
            { type: "answer", text: "EUR 1,165 minimum (20% paid-up)." },
        ],
    },
    {
        question: "Do Malta companies need audits?",
        content: [
            { type: "answer", text: "Yes — annual audited accounts are mandatory." },
        ],
    },
    {
        question: "How long does incorporation take?",
        content: [
            { type: "answer", text: "Usually 2–3 weeks." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We established our iGaming company in Malta. Offshore Advisory helped us obtain MGA licensing and handle tax structuring.",
        author: "Luca R.",
        role: "Gaming CEO",
    },
    {
        quote:
            "Our fintech venture needed EU credibility. A Malta Ltd gave us access to investors and banking.",
        author: "Sofia T.",
        role: "FinTech Founder",
    },
];